





















import {
  Component,
  Model,
  Prop,
  PropSync,
  Vue,
} from 'vue-property-decorator';

@Component({
  name: 'NightlyRatesCheckbox',
  components: {},
})
export default class NightlyRatesCheckbox extends Vue {
  @Prop({ default: false }) protected disabled?: boolean;

  @Prop() protected color!: any;

  @Prop() protected fill!: any;

  @PropSync('value', { type: Boolean }) protected valueSynced!: boolean;

  @Model('update:value') readonly value!: string;

  protected onToggle() {
    if (this.disabled) {
      return;
    }
    this.doToggle();
  }

  protected doToggle() {
    this.$emit('update:value', !this.valueSynced);
  }
}

